module.exports = __webpack_public_path__ + "media/images/benefits-easy-f9c51a381ecb23852b9db24b7ff86c4b.svg";